import { InjectionToken } from '@angular/core'

import { Observable } from 'rxjs'

import {
  NewOnPremOrganizationPayload,
  NewOrganizationPayload,
  NewOrganizationResponse,
} from './auth.types'

export const FX_ORGANIZATION_CODE_TOKEN = new InjectionToken<string>('FX_ORGANIZATION_CODE_TOKEN')
// cookie constant
export const FX_ORGANIZATION_CODE_COOKIE = 'FX-ORGANIZATION-CODE'
// host header
export const FX_CLIENT_HOST = 'Fx-Client-Host'
// query param constant
export const FX_ORGANIZATION_CODE = 'organizationCode'

export abstract class RegistrationApi {
  readonly registerNewOrganization: (
    payload: NewOrganizationPayload | NewOnPremOrganizationPayload
  ) => Observable<NewOrganizationResponse>
}

// registration from support
export const REGISTER_API = new InjectionToken<RegistrationApi>('REGISTER_API')
